module.exports = __webpack_public_path__ + "img/sg3.3210b94c.png";